import React, { useEffect, useState } from "react";
import SideButtons from "./SideButtons";
import {
  getObjectFromFirestore,
  reduceGeneralArray,
} from "../firebase/fireFuncs";
import useUpdateDetails from "../hooks/useUpdateDetails";
import BackButton from "../misc/elements/BackButton";
import collectionStore from "../stores/collectionStore";
import MainStore from "../stores/MainStore";
import CollectionButton from "./CollectionButton";
import DetailedCenter from "./DetailedCenter";
import DetailedBar from "./DetailedBar";
import SideButton from "./SideButtons";
import useModal from "../hooks/useModal";
import SafetyModal from "../modals/SafetyModal";
import useSimpleModal from "../hooks/useSimpleModal";
import useHandlePlayerArrays from "../hooks/useHandlePlayerArrays";
import { makeActiveObject, makeSavedObject } from "../create/saveObjects";
import { saveGoal } from "../misc/objects/objectFuncs";
import useCreateModal from "../hooks/useCreateModal";
import useHandleOpenObject from "../hooks/useHandleOpenObject";
import useHandleActiveGoal from "../hooks/useHandleActiveGoal";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import { toast } from "react-toastify";
const DetailedView = ({
  sizePercentage,
  handleActiveBox,
  handleActiveGoal,
}) => {
  const { detailedView, setDetailedView, player } = MainStore();
  const { addGeneralObjects } = collectionStore();
  const [catSelected, setCatSelected] = useState("general");
  const [objectImage, setObjectImage] = useState(null);
  const [keywords, setKeywords] = useState([]);
  const [categories, setCategories] = useState([]);
  const [putInActive, setPutInActive] = useState(false);
  const [boxType, setBoxType] = useState(null);
  const [things, setThings] = useState([]);
  const handleOpenObject = useHandleOpenObject({
    type: detailedView.general.type,
    onOpened: onObjectOpened,
    objects: detailedView,
  });
  const [saveObject, setSaveObject] = useState(false);
  const { getPluralType, getBoxType } = useHandleBoxTypes();

  const [firstLoad, setFirstLoad] = useState(true);
  const { removeObject, addObject } = useHandlePlayerArrays();
  const update = useUpdateDetails({ ...detailedView });
  const [open, setOpen] = useState(false);

  const safetyRemoveOpenModal = useSimpleModal({
    open: open,
    setOpen: setOpen,
    content: (
      <SafetyModal
        text={"Remove from Open?"}
        onComplete={removeOpenAfterSafety}
      />
    ),
  });
  const [savedOpen, setSavedOpen] = useState(false);
  const safetyRemoveSavedModal = useSimpleModal({
    open: savedOpen,
    setOpen: setSavedOpen,
    content: (
      <SafetyModal
        text={"Remove from Saved?"}
        onComplete={removeSavedAfterSafety}
      />
    ),
  });
  const [clicked, setClicked] = useState({});
  const [rated, setRated] = useState({
    general: { first: false, second: false },
    active: { first: false, second: false },
    completed: { first: false, second: false },
  });
  const buttons = ["general", "open", "saved", "history"];

  const [clicks, setClicks] = useState({});

  function onObjectOpened(openObject) {
    setDetailedView({ ...detailedView, open: openObject });
    if (putInActive) {
      handleActiveGoal.placeNewActive(makeActiveObject(openObject));
      setPutInActive(false);
    }
  }

  function changeRating(rating, field) {
    const newObject = { ...detailedView };
    newObject[catSelected].rating[rating[0]][rating[1]] = field;
    update.addChange({
      object: catSelected,
      field: ["rating", ...rating],
    });
    setDetailedView(newObject);
  }

  useEffect(() => {
    if (clicked.rating && clicked.field) {
      changeRating(clicked.rating, clicked.field);
    }
  }, [clicked]);

  function clickRated(rating, field) {
    setClicked({ rating, field });
  }

  function checkIfInActive() {
    var inActive = "none";
    const currentlyActiveBox = player.active.box;
    const currentlyActiveGoal = player.active.goal;
    console.log(
      " currentlyActiveBox - ",
      currentlyActiveBox,
      " | activeGoal -",
      currentlyActiveGoal
    );
    if (currentlyActiveBox) {
      if (currentlyActiveBox.id == detailedView.general.id) {
        inActive = "box";
      }
    } else if (currentlyActiveGoal) {
      if (currentlyActiveGoal.id == detailedView.general.id) {
        inActive = "goal";
      }
    }

    return inActive;
  }

  function moveToActive() {
    if (checkIfInActive() == "none") {
      setPutInActive(true);
      if (!detailedView.saved) {
        saveGoal(
          getPluralType,
          boxType,
          detailedView.general,
          player.uid,
          (savedObject) => {
            setDetailedView({ ...detailedView, saved: savedObject });
            addObject("saved", savedObject);
            setSaveObject(false);
            handleOpenObject.open();
          }
        );
      } else if (!detailedView.open) {
        handleOpenObject.open();
      } else {
        setPutInActive(false);
        handleActiveGoal.placeNewActive(makeActiveObject(detailedView.open));
      }
    } else {
      toast("Already Active");
    }
  }

  function onOpenObjectRemoved() {
    const whatActive = checkIfInActive();
    if (whatActive == "box") {
      handleActiveBox.stopActive(false);
    } else if (whatActive == "goal") {
      handleActiveGoal.stopActive(false);
    }
    reduceGeneralArray(
      getPluralType,
      detailedView.general.type,
      detailedView.general.id,
      "open",
      "player",
      player.uid,
      "id",
      () => {
        removeObject(detailedView.open, "open");
        setDetailedView({ ...detailedView, open: null });
      }
    );
  }

  function removeOpenAfterSafety(confirmed) {
    const isInActive = checkIfInActive();
    setOpen(false);
    if (isInActive == "none") {
      if (confirmed == "Yes") {
        onOpenObjectRemoved();
      }
    } else toast("can't remove while in  active");
  }

  function removeSavedAfterSafety(confirmed) {
    const isInActive = checkIfInActive();
    setSavedOpen(false);
    if (isInActive == "none") {
      if (confirmed == "Yes") {
        if (detailedView.open) {
          removeOpenAfterSafety("Yes");
        }

        reduceGeneralArray(
          getPluralType,
          detailedView.general.type,
          detailedView.general.id,
          "saved",
          "player",
          player.uid,
          "id",
          () => {
            removeObject(detailedView.saved, "saved");
            setDetailedView({ ...detailedView, saved: null, open: null });
          }
        );
      }
    } else toast("cant remove while in active");
  }

  function removeFromOpen() {
    safetyRemoveOpenModal.open();
  }

  function removeFromSaved() {
    safetyRemoveSavedModal.open();
  }

  function addRelated(name) {}

  function openReports() {}

  function setFoundBoxType() {
    const fbt = getBoxType(detailedView.general.type);

    setBoxType(fbt);
  }

  useEffect(() => {
    setFoundBoxType();
    const obj = {};
    obj.openReports = openReports;
    obj.clickRated = clickRated;
    obj.moveToActive = moveToActive;
    obj.removeFromOpen = removeFromOpen;
    obj.removeFromSaved = removeFromSaved;
    obj.addRelated = addRelated;
    setClicks(obj);
  }, []);

  function onCatSelected(cat) {
    setCatSelected(cat);
  }

  function getImage() {
    if (detailedView.open) {
      if (detailedView.open?.image?.length > 0) {
        setObjectImage(detailedView.open.image);
        return;
      }
    }
    if (detailedView.general.image?.length > 0) {
      setObjectImage(detailedView.general.image);
      return;
    } else setObjectImage(`/icons/icon_${detailedView.general.type}.png`);
  }

  function getKeywords() {
    if (detailedView.saved) {
      if (detailedView.saved.keywords.length > 0) {
        setKeywords(detailedView.saved.keywords);
        return;
      }
    }
    if (detailedView.general.keywords.length > 0) {
      setKeywords(detailedView.general.keywords);
      return;
    }
  }

  function getCategories() {
    if (detailedView.saved) {
      if (detailedView.saved.categories.length > 0) {
        setCategories(detailedView.saved.categories);
        return;
      }
    }
    if (detailedView.general.categories.length > 0) {
      setCategories(detailedView.general.categories);
      return;
    }
  }

  function getThings() {
    if (detailedView.saved) {
      if (detailedView.saved.things.length > 0) {
        setThings(detailedView.saved.things);
        return;
      }
    }
    if (detailedView.general.things.length > 0) {
      setThings(detailedView.general.things);
      return;
    }
  }

  function getGeneralObject() {
    const onObjectRecieved = (object) => {
      setDetailedView({ ...detailedView, general: object });
    };
    getObjectFromFirestore(
      detailedView.general.type,
      detailedView.general.id,
      addGeneralObjects,
      getPluralType,
      onObjectRecieved
    );
  }

  useEffect(() => {
    update.setOldObjects({ ...detailedView });
    setFirstLoad((bol) => {
      if (bol) {
        getImage();
        getKeywords();
        getCategories();
        getThings();
        getGeneralObject();
      }
      return false;
    });
  }, []);

  function openGoal() {
    const boxType = getBoxType(detailedView.general.type);
    if (!detailedView.saved) {
      saveGoal(
        getPluralType,
        boxType,
        detailedView.general,
        player.uid,
        (savedObject) => {
          setDetailedView({ ...detailedView, saved: savedObject });
          addObject("saved", savedObject);
          setSaveObject(false);
          handleOpenObject.open();
        }
      );
    } else {
      handleOpenObject.open();
    }
  }

  useEffect(() => {
    const boxType = getBoxType(detailedView.general.type);
    if (saveObject) {
      saveGoal(
        getPluralType,
        boxType,
        detailedView.general,
        player.uid,
        (savedObject) => {
          setDetailedView({ ...detailedView, saved: savedObject });
          addObject();
          setSaveObject(false);
        }
      );
    }
  }, [saveObject, detailedView]);

  function onButtonClicked(name) {
    const boxType = getBoxType(detailedView.general.type);
    if (name == "Open") {
      openGoal();
    } else if (name == "Save") {
      saveGoal(
        getPluralType,
        boxType,
        detailedView.general,
        player.uid,
        (savedObject) => {
          setDetailedView({ ...detailedView, saved: savedObject });
          addObject("saved", savedObject);
          setSaveObject(false);
        }
      );
    }
  }

  return (
    <div
      className="divColumn"
      style={{
        width: `${(1200 / 100) * sizePercentage.width}px`,
        minWidth: "800px",
        height: "60%",
        minHeight: "659px",
        borderRadius: "1rem/1rem",
        border: "5px solid grey",
        position: "relative",
        marginLeft: `${(20 / 100) * sizePercentage.width}%`,
        backgroundColor: boxType ? boxType.colors.primary : "grey",
      }}
    >
      <div
        className="divRow"
        style={{ position: "absolute", left: 0, marginLeft: "5px", top: 2 }}
      >
        <BackButton onClick={() => setDetailedView(null)} />
      </div>
      <img
        className="icon40"
        src={`/icons/icon_${detailedView.general.type}.png`}
        style={{ position: "absolute", right: 6, marginLeft: "5px", top: 2 }}
      />
      <div
        className="divRow"
        style={{ width: "100%", justifyContent: "space-around" }}
      >
        <SideButton
          name="Open"
          object={detailedView.open}
          type={detailedView.general.type}
          onButtonClicked={onButtonClicked}
          width="100%"
        />

        <div className="divRow" style={{ justifyContent: "space-around" }}>
          {buttons.map((button) => (
            <CollectionButton
              key={button}
              cat={button}
              onCatSelected={onCatSelected}
              selectedBoxType={catSelected}
            />
          ))}
        </div>
        <SideButton
          name="Save"
          object={detailedView.saved}
          type={detailedView.general.type}
          onButtonClicked={onButtonClicked}
          width="100%"
        />
      </div>

      <div className="divRow" style={{ width: "100%", flex: 1 }}>
        <DetailedBar
          catSelected={catSelected}
          objects={detailedView}
          clicks={clicks}
          position={"left"}
        />
        <DetailedCenter
          shortDescription={detailedView.general.shortDescription}
          type={detailedView.general.type}
          image={objectImage}
          categories={categories}
          keywords={keywords}
          things={things}
        />
        <DetailedBar
          position={"right"}
          clicks={clicks}
          catSelected={catSelected}
          objects={detailedView}
        />
      </div>
      {safetyRemoveOpenModal.element}
      {safetyRemoveSavedModal.element}
      {handleOpenObject.modal}
    </div>
  );
};

export default DetailedView;
